export const work = [
	{
		header: `Ropstam Solution`,
		subHeader: `Mern Stack Developer June 2022 – present`,
		para: [`Start working as Remote Mern Stack Developer, worked on following tech stack`],
		list: [`Mern`, `AWS`],
		img: `images/ropstom.png`,
		pullImg: "img-right",
		altText: `ropstom solution`,
		btnPara: `View Company`,
		internalLink: false,
		link: `https://www.ropstam.com/`,
	},
	{
		header: `Espresso Team`,
		subHeader: `Senior Full stack Developer (Remote) Jan 2020 – present`,
		para: [`Start working as Node js Developer that lead to Senior Full Stack Developer. Worked as following Technologies`],
		list: [`MERN Stack`, `AWS Lambda`, `Python`, `Java`, `Spring Boot`, `PostgresQL`, `Redis`, `Android`, `React Native`],
		img: `images/iccu.png`,
		pullImg: "img-left",
		altText: `espresso stack`,
		btnPara: `View Company`,
		internalLink: false,
		link: `https://www.espressostack.com/`,
	},
	{
		header: `Soft Thrive`,
		subHeader: `Mern Stack Developer (Remote) June 2020 – June 2021`,
		para: [`Worked as Mern Stack Developer`],
		list: [`Technologies`, `Mern Stack`, `React Native`, `Redux`, `AWS EC2`, `AWS Lambda`, `S3 Bucket`, `AWS Cognito`],
		img: `images/softThrive.png`,
		pullImg: "img-right",
		altText: `soft thrive`,
		btnPara: `View Company`,
		internalLink: false,
		link: `	https://www.softthrive.com/
		`,
	},
	{
		header: `Fistix`,
		subHeader: `Junior Software Engineer 2018—2019`,
		para: [`My role at Fistix was to manage backend as Nodejs developer, That lead to as Mern/Mean stack developer`],
		list: [`Nodejs`, `Loopback`, `Angular`, `React`, `July 2018 - July 2019`],
		img: `images/workhistory2.png`,
		pullImg: "img-left",
		altText: `Fistix`,
		btnPara: `View Company`,
		internalLink: false,
		link: `https://www.fistix.com/`,
	},
	{
		header: `United Software Solution`,
		subHeader: `Frontend Web Developer 2017 – 2018`,
		para: [`Worked as Junior Front end Developer as an Interny. That lead to Front End Developer`],
		list: [
			`Website redesign and architect restructure using HTML, SCSS, jQuery, and Wordpress`,
			`Landing page creation and form data collection single page application using HTML, SCSS,`,
			`jQuery, AJAX, and MongoDB`,
			`Email template development for Mailchimp email campaigns created with HTML, CSS, and MailChimp’s templating language.`,
			`Maintained HubSpot Marketing portal.`,
			`Oct 2017 - Mar 2018`,
		],
		img: `images/workhistory1.png`,
		pullImg: "img-right",
		altText: `United Software Website`,
		btnPara: `Learn about USS`,
		internalLink: false,
		link: `http://www.unitedsoft.net/`,
	},
];
